module.exports = __webpack_public_path__ + "static/media/all_product.d5c36459.jpg";